<!--
ダッシュボード  
-->
<template>
  <div>
    <template v-for="m in modelist">
      <input name="mode" v-model="mode" :value="m.id" type="radio" :id="'i_'+ m.id" />
      <label :for="'i_'+ m.id">{{m.name}}</label>
    </template>
  </div>

  <section class="container-xxl">
    <div class="container-xxl border my-4 p-4 rounded-3 overflow-auto max-hr-9">
      ログイン画面に表示する場合、ここにシステムメッセージを表示する。
      左右のサイズはログインコンテナより大きく設定。
      コンテナの最大高さを大きめに設定する。
      前回は実装できなかった<a href="#">リンクの設定</a>等も（将来的には簡単に設定）できるようにする。
    </div>

    <div class="container-xxl border my-4 p-4 rounded-3 overflow-auto max-hr-9">
      ログイン後のユーザー向けにシステムメッセージを表示する場合、ここ（ダッシュボード画面上部）に表示する。
      左右のサイズはダッシュボードコンテナと同等の設定（container-xxl）。
      コンテナの最大高さは、通常のシステムメッセージと同じく大きめに設定する。
      ここも前回は実装できなかった<a href="#">リンクの設定</a>等も（将来的には簡単に設定）できるようにする。
    </div>
  </section>

  <template v-if="mode=='dashboard'">
    <div class="container-xxl">
      <section class="mt-4 d-flex flex-column">
        <h6 class="mt-2">
          最近のお知らせ
          <span v-if='informations.some(i => i.opened === false)'>
            (
            {{informations.filter(i => i.opened === false).length}}
            )
          </span>
        </h6>
        <div class="container-xxl grid-hover border rounded-3 mt-2">
          <div class="row align-items-center py-2"
               v-for="information in informations"
               :class="{'fw-bold' : !information.opened}"
               role="row">
            <svgicon class="col-1 w-auto hr-2"
                     :name='information.pinned ? "pin_angle" : information.opened ? "envelope_open" : "envelope"' />
            <a href="#"
               class="col text-nowrap text-truncate
                               text-decoration-none text-dark">
              <span>{{information.title}}</span>
              <span class="m-2">&#045;</span>
              <span class="text-muted small">{{information.body}}</span>
            </a>
            <span class="col-auto">{{information.deliveredAtDisplay}}</span>
          </div>
        </div>
        <div class="text-end mt-2">
          <a href="#">全てのお知らせを確認する</a>
        </div>
      </section>

      <div class="container-xxl">
        <div class="row row-cols-1 row-cols-lg-2 flex-wrap d-flex mb-4">

          <div class="order-lg-1 p-0 ps-lg-1 col col-lg-8">

            <section class="mt-4 d-flex flex-column">
              <h6 class="mt-2">前回途中保存した章</h6>
              <div class="container-xxl border rounded-3 mt-2">
                <div class="row align-items-center py-2">
                  <img class="col-1 w-auto hr-5"
                       :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/book${15}.gif`" />
                  <div class="col">
                    <span class="d-block" role="button">チャプター（フェーズ）15</span>
                    <nav class="small text-break text-muted">
                      <a href="/courses">コース15</a>
                      <span class="mx-2">&gt;</span>
                      <a href="/courses">カテゴリ（分類）15</a>
                    </nav>
                  </div>
                </div>
              </div>
            </section>

            <section class="mt-4 d-flex flex-column">
              <h6 class="mt-2"
                  v-on:click="redirectTo('/Courses/details')">
                期限が近いコンテンツ
              </h6>

              <section class="mt-2">
                <button type="button" class="btn btn-outline-primary"
                        style="display: none;"
                        data-bs-toggle="collapse" aria-expanded="false" data-bs-target="#dashboard__search_container">
                  絞り込み
                </button>
                <div id="dashboard__search_container"
                     class="collapse show p-2 mt-2 border-top border-bottom small">
                  <div class="d-flex flex-wrap">
                    <section class="d-flex align-items-center me-4">
                      <span class="me-2 text-nowrap"> 期限日 &#058;</span>
                      <tabs-nav :list="limitTabList"
                                listStyle="rounded-pills"
                                class="small" />
                    </section>
                    <section class="d-flex align-items-center me-4">
                      <span class="me-2 text-nowrap"> 状態 &#058;</span>
                      <tabs-nav :list="statusTabList"
                                listStyle="rounded-pills"
                                class="small" />
                    </section>
                  </div>
                </div>
              </section>

              <div class="container-xxl grid-hover border rounded-3 mt-2">
                <div class="row align-items-center py-2"
                     v-for="(chapter, index) in chapterList"
                     :class='{"border-bottom" : index !== chapterList.length - 1}'
                     role="row"
                     v-on:click="redirectTo('/Courses/details')">
                  <div class="col-auto">
                    <img class="w-auto hr-4"
                         :src="`https://version280.cloud-manabibako.com/elearning/Image/icon/book${chapter.categoryId}.gif`" />
                    <progress-bar class="mt-1 small"
                                  :value="chapter.progress"
                                  :size="0.50" />
                  </div>
                  <div class="col">
                    <span class="d-block" role="button">{{chapter.name}}</span>
                    <nav class="small text-break text-muted">
                      <a :href="'/courses?categoryId=' + chapter.categoryId">{{chapter.categoryName}}</a>
                      <span class="mx-2">&gt;</span>
                      <a :href="'/courses?courseId=' + chapter.courseId">{{chapter.courseName}}</a>
                    </nav>
                  </div>
                </div>
              </div>
              <div class="text-end mt-2">
                <button type="button" class="btn btn-link" v-on:click="redirectTo('/Courses')">
                  全てのコンテンツを確認する
                </button>
              </div>
            </section>

          </div>

          <section class="mt-4 order-lg-0 p-0 pe-lg-1 d-flex flex-column col col-lg-4">
            <h6 class="mt-2">受講状況</h6>
            <stacked-bar-chart :chartData="chartItems" :chartOptions="chartOptions"
                               :percentageChart="true"
                               :funnelVisible="true"
                               :chartBackgroundVisible="true"
                               class="d-block d-lg-none border rounded-3 mt-2 p-2 hr-9" />

            <doughnut-chart :chartData="d_chartItems" :chartOptions="d_chartOptions"
                            :centerLabelVisible="true" :percentageChart="true"
                            class="d-none d-lg-block border rounded-3 mt-2 p-2 flex-grow-1"
                            :centerLabelScale="1.5" />

            <div class="text-end mt-2">
              <a href="#">受講状況の詳細を確認する</a>
            </div>
          </section>

        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="container d-flex row-cols-md-2 flex-md-wrap">
      <div class="d-flex p-md-2">
        <a class="d-flex align-items-center border rounded-3 my-4 m-md-2 p-2 text-reset text-decoration-none flex-grow-1"
           href="">
          <div class="position-relative hr-5 m-4">
            <svgicon name="envelope" class="h-100 w-auto" />
          </div>
          <div>
            <h3 class="d-flex align-items-center">
              お知らせ
              <span class="badge rounded-pill bg-danger ms-2">2</span>
            </h3>
            <span class="text-muted">管理者からのお知らせを確認できます。</span>
          </div>
        </a>
      </div>
      <div class="d-flex p-md-2">
        <a class="d-flex align-items-center border rounded-3 my-4 m-md-2 p-2 text-reset text-decoration-none flex-grow-1"
           href="/Courses">
          <div class="position-relative hr-5 m-4">
            <svgicon name="book" class="h-100 w-auto" />
            <svgicon name="lightbulb" class="__lightbulb_icon  position-absolute h-50 w-auto start-50 translate-middle" />
          </div>
          <div>
            <h3 class="d-flex align-items-center">
              受講
              <svgicon name="exclamation_circle" class="text-danger ms-2 hr-2 w-auto" />
            </h3>
            <span class="text-muted">現在公開されているコンテンツを一覧で選んで受講できます。</span>
          </div>
        </a>
      </div>
      <div class="d-flex p-md-2">
        <a class="d-flex align-items-center border rounded-3 my-4 m-md-2 p-2 text-reset text-decoration-none flex-grow-1"
           href="/Courses">
          <div class="position-relative hr-5 m-4">
            <svgicon name="boxes" class="h-100 w-auto" />
          </div>
          <div>
            <h3 class="d-flex align-items-center">
              受講履歴
            </h3>
            <span class="text-muted">過去に受講したコンテンツを確認できます。</span>
          </div>
        </a>
      </div>
      <div class="d-flex p-md-2">
        <a class="d-flex align-items-center border rounded-3 my-4 m-md-2 p-2 text-reset text-decoration-none flex-grow-1"
           href="">
          <div class="position-relative hr-5 m-4">
            <svgicon name="clipboard_data" class="h-100 w-auto" />
          </div>
          <div>
            <h3>学習状況</h3>
            <span class="text-muted">ご自身の現在の学習状況を確認できます。</span>
          </div>
        </a>
      </div>
    </div>
</template>
</template>

<style scoped>
  .__lightbulb_icon {
    filter: drop-shadow(0.1rem 0 var(--bs-body-bg)) drop-shadow(0 0.1rem var(--bs-body-bg)) drop-shadow(0.1rem 0.1rem var(--bs-body-bg)) drop-shadow(-0.1rem 0 var(--bs-body-bg)) drop-shadow(0 -0.1rem var(--bs-body-bg)) drop-shadow(-0.1rem -0.1rem var(--bs-body-bg)) drop-shadow(-0.1rem 0.1rem var(--bs-body-bg)) drop-shadow(0.1rem -0.1rem var(--bs-body-bg));
    top: 40%;
    fill: var(--bs-yellow);
  }
</style>

<script>
  import { defineComponent } from "vue";
  import { xhrRequest, xhrErrors } from "utils/xhr";
  import Spinner from "utils/spinner";
  import { format } from 'date-fns';
  import validationErrors from "components/base/validation_errors";

  import DoughnutChart from "components/chart/doughnut_chart";
  import BarChart from "components/chart/bar_chart";
  import StackedBarChart from "components/chart/stacked_bar_chart";

  import ProgressBarControl from "components/control/progress_bar_control";

  import TabsNav from "components/nav/tabs_nav";

  const onInit = () => {
  };

  const onMounted = function () {
    this.chartItems.datasets[0].label = this.$t("status.attended");
    this.chartItems.datasets[1].label = this.$t("status.in_attending");
    this.chartItems.datasets[2].label = this.$t("status.not_attended");
    this.chartItems.datasets[3].label = this.$t("status.expired");
    this.d_chartItems.datasets[0].label = "aa";
    this.d_chartItems.labels[0] = this.$t("status.attended");
    this.d_chartItems.labels[1] = this.$t("status.in_attending");
    this.d_chartItems.labels[2] = this.$t("status.not_attended");
    this.d_chartItems.labels[3] = this.$t("status.expired");
  };

  const methods = {
    redirectTo: function (url) {
      window.location = url;
    },
    progressStyle(num) {
      if (num == null || !Number.isFinite(num) || num < 0) {
        num = 0;
      }
      return `width: ${num}%;`
    },
  };

  const computed = {
  };

  export default defineComponent({
    template: "#container",
    data: () => {
      return {
        mode: "simple",
        modelist: [
          {
            id: "simple",
            name: "シンプル",
          },
          {
            id: "dashboard",
            name: "ダッシュボード",
          },
        ],
        informations: [
          {
            id: 1,
            title: "お知らせメール1",
            body: "お知らせメール1に記載されている本文の例1",
            deliveredAtDisplay: "00:02",
            deliveredAtDetailDisplay: "2022/05/28 00:02",
            opened: true,
            pinned: true,
          },
          {
            id: 2,
            title: "お知らせメール2（件名長めの場合の例）",
            body: "お知らせメール2に記載されている本文の例2。改行等はないけれど、ある程度の文字数がある本文の例。合計文字数は大体100文字前後。",
            deliveredAtDisplay: "05/14",
            deliveredAtDetailDisplay: "2022/05/14 08:58",
            opened: false,
            pinned: false,
          },
          {
            id: 3,
            title: "お知らせメール3（件名が非常に長い場合の例。件名は最大100～200程度の長さを想定しています。）",
            body: "お知らせメール3に記載されている本文の例3。本文の長さが非常に長い例。以下繰り返し。012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789012345789",
            deliveredAtDisplay: "05/01",
            deliveredAtDetailDisplay: "2022/05/01 09:00",
            opened: false,
            pinned: true,
          },
          {
            id: 4,
            title: "お知らせメール4（配信日時が非常に古いもの）",
            body: "お知らせメール4本文。",
            deliveredAtDisplay: "2021/12/28",
            deliveredAtDetailDisplay: "2021/12/28 09:00",
            opened: true,
            pinned: false,
          },
        ],
        chapterList: [
          {
            id: 1,
            name: "チャプター（フェーズ）01",
            courseId: 1,
            courseName: "コース01",
            categoryId: 1,
            categoryName: "カテゴリ（分類）01",
            limitedAt: "2022/07/30",
            progress: 75,
          },
          {
            id: 2,
            name: "チャプター（フェーズ）02",
            courseId: 1,
            courseName: "コース01",
            categoryId: 1,
            categoryName: "カテゴリ（分類）01",
            limitedAt: "2022/07/30",
            progress: 60,
          },
          {
            id: 3,
            name: "チャプター（フェーズ）03",
            courseId: 1,
            courseName: "コース01",
            categoryId: 1,
            categoryName: "カテゴリ（分類）01",
            limitedAt: "2022/07/30",
            progress: 30,
          },
          {
            id: 4,
            name: "チャプター（フェーズ）01",
            courseId: 2,
            courseName: "コース02",
            categoryId: 1,
            categoryName: "カテゴリ（分類）01",
            limitedAt: "2022/07/30",
            progress: 5,
          },
          {
            id: 5,
            name: "チャプター（フェーズ）02",
            courseId: 2,
            courseName: "コース02",
            categoryId: 1,
            categoryName: "カテゴリ（分類）01",
            limitedAt: "2022/07/30",
            progress: 0,
          },
          {
            id: 6,
            name: "チャプター（フェーズ）01",
            courseId: 3,
            courseName: "コース01",
            categoryId: 2,
            categoryName: "カテゴリ（分類）01",
            limitedAt: "2022/07/30",
            progress: 80,
          },
        ],
        chartItems: {
          labels: ["受講状況",],
          datasets: [
            {
              data: [7,],
              backgroundColor: __COLOR_CODE.primary,
            },
            {
              data: [8,],
              backgroundColor: __COLOR_CODE.warning,
            },
            {
              data: [4,],
              backgroundColor: __COLOR_CODE.danger,
            },
            {
              data: [2,],
              backgroundColor: __COLOR_CODE.secondary,
            },
          ]
        },
        chartOptions: {
          indexAxis: "y",
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            labels: {
              render: "percentage",
            },
            legend: {
            },
          },
          scales: {
            title: {
              display: false,
            },
            x: {
              display: false,
            },
            y: {
              display: false,
            }
          },
        },
        d_chartItems: {
          labels: ["", "", "", ""],
          datasets: [
            {
              data: [7, 8, 4, 2],
              backgroundColor: [__COLOR_CODE.primary, __COLOR_CODE.warning, __COLOR_CODE.danger, __COLOR_CODE.secondary,]
            },
          ]
        },
        d_chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            labels: {
              render: "percentage",
            },
            legend: {
              position: "right",
            },
          },
          scales: {
            title: {
              display: false,
            },
            x: {
              display: false,
              min: 0,
              max: 100,
            },
            y: {
              display: false,
              min: 0,
              max: 100,
            }
          },
        },
        limitTabList: [
          {
            id: 1,
            title: "全て",
          },
          {
            id: 2,
            title: "1週間以内",
          },
          {
            id: 3,
            title: "今日まで",
          },
        ],
        statusTabList: [
          {
            id: 1,
            title: "全て",
          },
          {
            id: 2,
            title: "完了以外",
          },
        ],
      }
    },
    created: onInit,
    mounted: onMounted,
    methods: methods,
    computed: computed,
    components: {
      "stacked-bar-chart": StackedBarChart,
      "doughnut-chart": DoughnutChart,
      "bar-chart": BarChart,
      "tabs-nav": TabsNav,
      "progress-bar": ProgressBarControl,
    },
  });
</script>
